import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaGithub, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navigationLinks = [
    { to: '/', label: t('navbar.home') },
    { to: '/hakkimizda', label: t('navbar.about') },
    { to: '/hizmetlerimiz', label: t('navbar.services') },
    { to: '/iletisim', label: t('navbar.contact') },
  ];

  const socialLinks = [
    // { name: 'LinkedIn', icon: FaLinkedin, href: '#' },
    // { name: 'Twitter', icon: FaTwitter, href: '#' },
    // { name: 'GitHub', icon: FaGithub, href: '#' },
    // { name: 'Instagram', icon: FaInstagram, href: '#' },
  ];

  return (
    <footer className="border-t border-gray-200 bg-white text-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 justify-between">
          {/* Marka bloğu */}
          <div className="lg:max-w-md">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/Laynext_Turuncu.png"
                alt="Laynext Logo"
                className="h-16 w-16 sm:h-20 sm:w-20 object-contain"
              />
            
            </div>
            <p className="text-sm text-gray-500 leading-relaxed">
              {t('footer.description')}
            </p>

            <div className="mt-6 flex items-center gap-3">
              {socialLinks.map(({ name, icon: Icon, href }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={name}
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-300 text-gray-500 hover:text-laynext-orange hover:border-laynext-orange transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigasyon + İletişim */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-8">
            <div>
              <h4 className="text-xs font-semibold tracking-wide text-gray-500 uppercase">
                {t('footer.companyHeading')}
              </h4>
              <div className="mt-4 space-y-3 text-sm">
                {navigationLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={scrollToTop}
                    className="block text-gray-600 hover:text-laynext-orange transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold tracking-wide text-gray-500 uppercase">
                {t('footer.contactHeading')}
              </h4>
              <div className="mt-4 space-y-3 text-sm text-gray-600">
                <a
                  href="mailto:info@laynext.net"
                  className="block hover:text-laynext-orange transition-colors"
                >
                  info@laynext.net
                </a>
                <a
                  href="tel:+905382755371"
                  className="block hover:text-laynext-orange transition-colors"
                >
                  +90 (538) 275 53 71
                </a>
                <p>{t('footer.location')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-10 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-gray-200 pt-4 sm:pt-6">
          <p className="text-xs text-gray-500">
            &copy; {currentYear} Laynext. {t('footer.rights')}
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-gray-500">
            <a href="#" className="hover:text-laynext-orange transition-colors">
              {t('footer.privacy')}
            </a>
            <span className="h-3 w-px bg-gray-300 hidden sm:inline-block" />
            <a href="#" className="hover:text-laynext-orange transition-colors">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
